
define('app/dashboard/leagues/instances/views/lgInstSettingsView',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/userModel',
	'known/models/leagueInstanceModel',
	'known/models/productModel',
	
	//Shims
	'jquery.uniform'
], function(
		$, 
		_, 
		Backbone, 
		UserModel, 
		LeagueInstanceModel,
		ProductModel){

	var EditLeagueFooterView = Backbone.View.extend({
		events: {
			'click #editLgFormSubmit': 'submitLeagueForm',
		},
		
		initialize: function(options) {
			this.event = options.event;
			
			this.showLeagueForm();
			
			this.listenTo(this.event, 'default', this.showLeagueForm);
			this.listenTo(this.event, 'saving', this.hideAll);
			this.listenTo(this.event, 'error', this.showLeagueForm);
			this.listenTo(this.event, 'success', this.showLeagueForm);
		},
		
		hideAll: function () {
			this.$("#editLgSubmitFooter").hide();
			this.$("#editLgFormCancel").hide();
		},
		
		submitLeagueForm: function () {
			this.event.trigger("save");
		},
		
		showLeagueForm: function () {
			this.hideAll();
			this.$("#editLgSubmitFooter").show();
			this.$("#editLgFormCancel").show();
		}
	});

	var EditLeagueContentView = Backbone.View.extend({	
		initialize: function(options) {
			this.hideAll();
			
			this.event = options.event;
			this.submittedData = options.submittedData;
			this.userModel = options.userModel; 
			this.lgInstance = options.lgInstance;
			this.prodConfig = options.prodConfig;
			this.prodType = options.prodType;
			
			_.bindAll(this, 'successCallback');
			_.bindAll(this, 'errorCallback');
			
			this.listenTo(this.event, 'save', this.submitLeague);
			this.listenTo(this.event, 'default', this.hideAll);
			this.listenTo(this.event, 'saving', this.hideAll);
			this.listenTo(this.event, 'error', this.leagueForm);
			this.listenTo(this.event, 'success', this.leagueForm);
			
			//Error handling
			this.listenTo(this.event, 'error:displayname', this.errorDispName);
			this.listenTo(this.event, 'error:drafttype', this.errorType);
			this.listenTo(this.event, 'error:numrounds', this.errorNumRounds);
			this.listenTo(this.event, 'error:timerExpType', this.errorTimerExpiration);
			this.listenTo(this.event, 'error:undoEnabled', this.errorUndoEnabled);
			this.listenTo(this.event, 'error:ranksenabled', this.errorRanksEnabled);
			this.listenTo(this.event, 'error:statsenabled', this.errorProjectionsEnabled);
			this.listenTo(this.event, 'error:rookieenabled', this.errorRookiesEnabled);
			this.listenTo(this.event, 'error:vetenabled', this.errorRookiesEnabled);
			this.listenTo(this.event, 'error:conf1enabled', this.errorConferencesEnabled);
			this.listenTo(this.event, 'error:conf2enabled', this.errorConferencesEnabled);
		},
		
		render: function() {
			this.populateTeamDropdown();
			
			if(this.lgInstance.get("draftStatus") == "COMPLETED"){
				this.$("#editLgTypeGrp").hide();
				this.$("#editLgRoundsSelGrp").hide();
			} else if(this.lgInstance.get("draftStatus") != "SETUP"){
				if(this.lgInstance.get('draftType') == 'SNAKE'){
					this.$("#editLgTypeStandardRadio").hide();
					this.$("#editLgTypeAuctionRadio").hide();
				} else if(this.lgInstance.get('draftType') == 'STANDARD'){
					this.$("#editLgTypeSnakeRadio").hide();
					this.$("#editLgTypeAuctionRadio").hide();
				} else {
					this.$("#editLgTypeGrp").hide();
				}				
			} else if(this.lgInstance.get('draftType') == 'AUCTION'){
				this.$("#editLgTypeGrp").hide();
				$("#lgInfoTimerExpGrp").hide();
				this.$("#editLgTimerExpirationGrp").hide();
			}
			
			//Determine whether to show upgrade options
			if(this.prodConfig.CUSTORDER == 'true'){
				this.$("#editLgTypeCustomRadioLabel").html('Custom Order');		
				this.$("#editLgTypeCustom").removeProp('disabled');
				this.$("#editLgTypeCustomRadio").removeClass('disabled');
			} else {
				this.$("#editLgTypeCustomRadioLabel").html('Custom Order (<a href="/draftapp/dashboard/purchase">Upgrade</a> to enable)');
				this.$("#editLgTypeCustom").prop('disabled', 'disabled');
				this.$("#editLgTypeCustomRadio").addClass('disabled');
			}
			
			if(this.prodConfig.AUTODRAFT == 'true'){
				this.$("#editLgTimerExpirationAutoDraftRecommendedRadioLabel").html('Autodraft - Recommended (Based on rankings and positions)');
				this.$("#editLgTimerExpirationAutoDraftRadioLabel").html('Autodraft - Best Ranked (Rankings only)');
				this.$("#editLgTimerExpirationManualRadioLabel").html('Manual - Timer will stay expired');
				this.$("#editLgTimerExpirationAutodraftRecommended").removeProp('disabled');
				this.$("#editLgTimerExpirationAutodraft").removeProp('disabled');
				this.$("#editLgTimerExpirationAutodraftRadio").removeClass('disabled');
			} else {
				this.$("#editLgTimerExpirationAutoDraftRecommendedRadioLabel").html('Autodraft - Recommended (Based on rankings and positions)  (<a href="/draftapp/dashboard/purchase">Upgrade</a> to enable)');
				this.$("#editLgTimerExpirationAutoDraftRadioLabel").html('Autodraft - Best Ranked (Rankings only) (<a href="/draftapp/dashboard/purchase">Upgrade</a> to enable)');
				this.$("#editLgTimerExpirationManualRadioLabel").html('Manual - Timer will stay expired');
				this.$("#editLgTimerExpirationAutodraftRecommended").prop('disabled', 'disabled');
				this.$("#editLgTimerExpirationAutodraft").prop('disabled', 'disabled');
				this.$("#editLgTimerExpirationAutodraftRadio").addClass('disabled');
			}
			
			if(this.prodConfig.AUCTION == 'true'){
				this.$("#editLgTypeAuctionRadioLabel").html('Auction');		
				this.$("#editLgTypeAuction").removeProp('disabled');
				this.$("#editLgTypeAuctionRadio").removeClass('disabled');
			} else {
				this.$("#editLgTypeAuctionRadioLabel").html('Auction (<a href="/draftapp/dashboard/purchase">Upgrade</a> to enable)');
				this.$("#editLgTypeAuction").prop('disabled', 'disabled');
				this.$("#editLgTypeAuctionRadio").addClass('disabled');
			}
			
			if(this.prodConfig.ROOKIE == 'true'){
				this.$("#editLgRookiesEnabledRookiesLabel").html('Rookies Only');
				this.$("#editLgRookiesEnabledRookies").removeProp('disabled');
				this.$("#editLgRookiesEnabledRookiesRadio").removeClass('disabled');
				
				this.$("#editLgRookiesEnabledVetsLabel").html('Veterans Only');
				this.$("#editLgRookiesEnabledVets").removeProp('disabled');
				this.$("#editLgRookiesEnabledVetsRadio").removeClass('disabled');
			} else {
				this.$("#editLgRookiesEnabledRookiesLabel").html('Rookies Only (<a href="/draftapp/dashboard/purchase">Upgrade</a> to enable)');
				this.$("#editLgRookiesEnabledRookies").prop('disabled', 'disabled');
				this.$("#editLgRookiesEnabledRookiesRadio").addClass('disabled');
				
				this.$("#editLgRookiesEnabledVetsLabel").html('Veterans Only (<a href="/draftapp/dashboard/purchase">Upgrade</a> to enable)');
				this.$("#editLgRookiesEnabledVets").prop('disabled', 'disabled');
				this.$("#editLgRookiesEnabledVetsRadio").addClass('disabled');
			}
			
			if(this.prodConfig.CONF == 'true'){
				this.$("#editLgConferencesEnabledConf1").removeProp('disabled');
				this.$("#editLgConferencesEnabledConf1Radio").removeClass('disabled');			
				this.$("#editLgConferencesEnabledConf2").removeProp('disabled');
				this.$("#editLgConferencesEnabledConf2Radio").removeClass('disabled');
				
				switch (this.lgInstance.get('prodLeagueName')) {
				case 'NFL':
					this.$("#editLgConferencesEnabledConf1Label").html('AFC Only');
					this.$("#editLgConferencesEnabledConf2Label").html('NFC Only');
					break;
				case 'MLB':
					this.$("#editLgConferencesEnabledConf1Label").html('AL Only');
					this.$("#editLgConferencesEnabledConf2Label").html('NL Only');
					break;
				case 'NBA':
					this.$("#editLgConferencesEnabledConf1Label").html('Eastern Only');
					this.$("#editLgConferencesEnabledConf2Label").html('Western Only');
					break;
				case 'NHL':
					this.$("#editLgConferencesEnabledConf1Label").html('Eastern Only');
					this.$("#editLgConferencesEnabledConf2Label").html('Western Only');
					break;
				default:
					break;
				}
			} else {
				this.$("#editLgConferencesEnabledConf1").prop('disabled', 'disabled');
				this.$("#editLgConferencesEnabledConf1Radio").addClass('disabled');
				this.$("#editLgConferencesEnabledConf2").prop('disabled', 'disabled');
				this.$("#editLgConferencesEnabledConf2Radio").addClass('disabled');
				
				switch (this.lgInstance.get('prodLeagueName')) {
				case 'NFL':
					this.$("#editLgConferencesEnabledConf1Label").html('AFC Only (<a href="/draftapp/dashboard/purchase">Upgrade</a> to enable)');
					this.$("#editLgConferencesEnabledConf2Label").html('NFC Only (<a href="/draftapp/dashboard/purchase">Upgrade</a> to enable)');
					break;
				case 'MLB':
					this.$("#editLgConferencesEnabledConf1Label").html('AL Only (<a href="/draftapp/dashboard/purchase">Upgrade</a> to enable)');
					this.$("#editLgConferencesEnabledConf2Label").html('NL Only (<a href="/draftapp/dashboard/purchase">Upgrade</a> to enable)');
					break;
				case 'NBA':
					this.$("#editLgConferencesEnabledConf1Label").html('Eastern Only (<a href="/draftapp/dashboard/purchase">Upgrade</a> to enable)');
					this.$("#editLgConferencesEnabledConf2Label").html('Western Only (<a href="/draftapp/dashboard/purchase">Upgrade</a> to enable)');
					break;
				case 'NHL':
					this.$("#editLgConferencesEnabledConf1Label").html('Eastern Only (<a href="/draftapp/dashboard/purchase">Upgrade</a> to enable)');
					this.$("#editLgConferencesEnabledConf2Label").html('Western Only (<a href="/draftapp/dashboard/purchase">Upgrade</a> to enable)');
					break;
				default:
					break;
				}
			}
			
			if(this.lgInstance.get('prodLeagueName') != 'NFL'){
				this.$("#editLgRookiesEnabledGrp").hide();
			} else {
				this.$("#editLgRookiesEnabledGrp").show();
			}
			
			//Disable auction until it is built out
			this.$("#editLgTypeAuctionRadio").hide();
			
			//Initialize fields
			this.$("#editLgTypeSelInput").val(this.lgInstance.get("draftType"));
			this.$("#editLgRoundsSelInput").val(this.lgInstance.get("numRounds"));
			
			var typeRadios = this.$('input[name=editLgType]');
			typeRadios.filter('[value=' + this.lgInstance.get("draftType") +']').prop('checked', true);
			
			var timerExpTypeRadios = this.$('input[name=editLgTimerExpiration]');
			timerExpTypeRadios.filter('[value=' + this.lgInstance.get("timerExpType") +']').prop('checked', true);
			
			var undoRadios = this.$('input[name=editLgUndo]');
			undoRadios.filter('[value=' + (this.lgInstance.get("undoEnabled") ? 'true' : 'false') +']').prop('checked', true);
			
			var ranksEnabledRadios = this.$('input[name=editLgRanksEnabled]');
			ranksEnabledRadios.filter('[value=' + (this.lgInstance.get("ranksEnabled") ? 'true' : 'false') +']').prop('checked', true);
			
			var projsEnabledRadios = this.$('input[name=editLgProjectionsEnabled]');
			projsEnabledRadios.filter('[value=' + (this.lgInstance.get("statsEnabled") ? 'true' : 'false') +']').prop('checked', true);
			
			var rookiesEnabledRadios = this.$('input[name=editLgRookiesEnabled]');
			var rookiesEnabledValue = "";
			if(this.lgInstance.get("rookieEnabled") == this.lgInstance.get("vetEnabled")){
				rookiesEnabledValue = "both";
			} else if(this.lgInstance.get("rookieEnabled")){
				rookiesEnabledValue = "rookies";
			} else {
				rookiesEnabledValue = "vets";
			}
			rookiesEnabledRadios.filter('[value=' + rookiesEnabledValue +']').prop('checked', true);
			
			var conferencesEnabledRadios = this.$('input[name=editLgConferencesEnabled]');
			var conferencesEnabledValue = "";
			if(this.lgInstance.get("conf1Enabled") == this.lgInstance.get("conf2Enabled")){
				conferencesEnabledValue = "both";
			} else if(this.lgInstance.get("conf1Enabled")){
				conferencesEnabledValue = "conf1";
			} else {
				conferencesEnabledValue = "conf2";
			}
			conferencesEnabledRadios.filter('[value=' + conferencesEnabledValue +']').prop('checked', true);
			
			if(!this.lgInstance.get("displayName")){
				this.$("#editLgDispNameInput").val(this.lgInstance.get("leagueName").toLowerCase());
			} else {
				this.$("#editLgDispNameInput").val(this.lgInstance.get("displayName"));
			}
			
			$(this.el).find('.styled').uniform({radioClass: 'choice', selectAutoWidth: false});
			
			return this;
		},
		
		populateTeamDropdown: function () {
			this.$("#editLgRoundsSelInput").empty();
			
			var initialRound = 3;
			
			if(this.lgInstance.get('draftStatus') != 'SETUP'){
				initialRound = this.lgInstance.get('numRounds');
			}
			
			for (var i = initialRound; i <= 55 ; i++) {
				var optionStart = "<option value=\"";
				var optionMiddle = "\" >";
				var optionEnd = "</option>";
				var selected = "";
				
				if(i == this.lgInstance.get('numRounds')){
					selected = "\" selected=\"true";
				}
				
				this.$("#editLgRoundsSelInput").append(optionStart 
						+ i
						+ selected
						+ optionMiddle
						+ i		
						+ optionEnd);	
			}
			
			$(this.el).find('.styled').uniform({radioClass: 'choice', selectAutoWidth: false});
		},
		
		submitLeague: function () {
			if(!this.submittedData.isSubmitted){
				this.event.trigger("saving");
				
				this.submittedData.isSubmitted = true;
				
				var rookiesRadioVal = this.$('input[name=editLgRookiesEnabled]:checked').val();
				var confRadioVal = this.$('input[name=editLgConferencesEnabled]:checked').val();
				
				var rookiesEnabled = rookiesRadioVal == 'both' || rookiesRadioVal == 'rookies' ? true : false;
				var vetsEnabled = rookiesRadioVal == 'both' || rookiesRadioVal == 'vets' ? true : false;
				var conf1Enabled = confRadioVal == 'both' || confRadioVal == 'conf1' ? true : false;
				var conf2Enabled = confRadioVal == 'both' || confRadioVal == 'conf2' ? true : false;
				
				this.lgInstance.save({
					displayName: this.$("#editLgDispNameInput").val(),
					draftType: this.$('input[name=editLgType]:checked').val(),
					timerExpType: this.$('input[name=editLgTimerExpiration]:checked').val(),
					numRounds: this.$("#editLgRoundsSelInput").val(),
					undoEnabled: this.$('input[name=editLgUndo]:checked').val() == 'false'? false : true,
					ranksEnabled: this.$('input[name=editLgRanksEnabled]:checked').val() == 'false'? false : true,
					statsEnabled: this.$('input[name=editLgProjectionsEnabled]:checked').val() == 'false'? false : true,
					rookieEnabled: rookiesEnabled,
					vetEnabled: vetsEnabled,
					conf1Enabled: conf1Enabled,
					conf2Enabled: conf2Enabled	
				},{wait: true,
					success : this.successCallback, 
					error : this.errorCallback
				});
			}
		},
		
		successCallback: function(model, response) {
			this.event.trigger("savingSuccess", model, response);
		},
		
		errorCallback: function(model, error) {
			this.event.trigger("savingError", model, error);
		},
		
		hideAll: function() {
			$(this.el).hide();
			
			//Hide error messages
			this.$("#editLgDispNameGrp").removeClass("error");
			this.$("#editLgDispNameInput").removeClass("error");
			this.$("#editLgDispNameErrMsg").hide();
			
			this.$("#editLgTypeGrp").removeClass("error");
			this.$("#editLgTypeErrMsg").hide();
			
			this.$("#editLgRoundsSelGrp").removeClass("error");
			this.$("#editLgRoundsSelErrMsg").hide();
			
			this.$("#editLgTimerExpirationGrp").removeClass("error");
			this.$("#editLgTimerExpirationErrMsg").hide();
			
			this.$("#editLgUndoGrp").removeClass("error");
			this.$("#editLgUndoErrMsg").hide();
			
			this.$("#editLgRanksEnabledGrp").removeClass("error");
			this.$("#editLgRanksEnabledErrMsg").hide();
			
			this.$("#editLgProjectionsEnabledGrp").removeClass("error");
			this.$("#editLgProjectionsEnabledErrMsg").hide();
			
			this.$("#editLgRookiesEnabledGrp").removeClass("error");
			this.$("#editLgRookiesEnabledErrMsg").hide();
			
			this.$("#editLgConferencesEnabledGrp").removeClass("error");
			this.$("#editLgConferencesEnabledErrMsg").hide();
		},
		
		leagueForm: function () {
			this.hideAll();
			$(this.el).show();
		},
		
		errorDispName : function (errorCode) {
			this.$("#editLgDispNameGrp").addClass("error");
			this.$("#editLgDispNameInput").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#editLgDispNameErrMsg").html("League name is empty");
					this.$("#editLgDispNameErrMsg").show();
					break;
				case "LENGTH":
					this.$("#editLgDispNameErrMsg").html("League name must be between 5 and 30 characters long");
					this.$("#editLgDispNameErrMsg").show();
					break;
				case "ALPHANUMSPACE":
					this.$("#editLgDispNameErrMsg").html("League name may only contain alpha numeric characters and spaces");
					this.$("#editLgDispNameErrMsg").show();
					break;
				default : 
					this.$("#editLgDispNameErrMsg").html("League name is invalid");
					this.$("#editLgDispNameErrMsg").show();
			}
		},
		
		errorType : function (errorCode) {
			this.$("#editLgTypeGrp").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#editLgTypeErrMsg").html("Draft type is empty");
					this.$("#editLgTypeErrMsg").show();
					break;
				default : 
					this.$("#editLgTypeErrMsg").html("Draft type is invalid");
					this.$("#editLgTypeErrMsg").show();
			}
		},
		
		errorNumRounds : function (errorCode) {
			this.$("#editLgRoundsSelGrp").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#editLgRoundsSelErrMsg").html("Number of rounds is empty");
					this.$("#editLgRoundsSelErrMsg").show();
					break;
				default : 
					this.$("#editLgRoundsSelErrMsg").html("Number of rounds is invalid");
					this.$("#editLgRoundsSelErrMsg").show();
			}
		},
		
		errorTimerExpiration : function (errorCode) {
			this.$("#editLgTimerExpirationGrp").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#editLgTimerExpirationErrMsg").html("Timer expiration input is empty");
					this.$("#editLgTimerExpirationErrMsg").show();
					break;
				default : 
					this.$("#editLgTimerExpirationErrMsg").html("Timer expiration is invalid");
					this.$("#editLgTimerExpirationErrMsg").show();
			}
		},
		
		errorUndoEnabled : function (errorCode) {
			this.$("#editLgUndoGrp").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#editLgUndoErrMsg").html("Undo allowed input is empty");
					this.$("#editLgUndoErrMsg").show();
					break;
				default : 
					this.$("#editLgUndoErrMsg").html("Undo allowed input is invalid");
					this.$("#editLgUndoErrMsg").show();
			}
		},
		
		errorRanksEnabled : function (errorCode) {
			this.$("#editLgRanksEnabledGrp").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#editLgRanksEnabledErrMsg").html("Ranking input is empty");
					this.$("#editLgRanksEnabledErrMsg").show();
					break;
				default : 
					this.$("#editLgRanksEnabledErrMsg").html("Ranking input is invalid");
					this.$("#editLgRanksEnabledErrMsg").show();
			}
		},
		
		errorProjectionsEnabled : function (errorCode) {
			this.$("#editLgProjectionsEnabledGrp").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#editLgProjectionsEnabledErrMsg").html("Projections input is empty");
					this.$("#editLgProjectionsEnabledErrMsg").show();
					break;
				default : 
					this.$("#editLgProjectionsEnabledErrMsg").html("Projections input is invalid");
					this.$("#editLgProjectionsEnabledErrMsg").show();
			}
		},
		
		errorRookiesEnabled : function (errorCode) {
			this.$("#editLgRookiesEnabledGrp").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#editLgRookiesEnabledErrMsg").html("Rookies input is empty");
					this.$("#editLgRookiesEnabledErrMsg").show();
					break;
				default : 
					this.$("#editLgRookiesEnabledErrMsg").html("Rookies input is invalid");
					this.$("#editLgRookiesEnabledErrMsg").show();
			}
		},
		
		errorConferencesEnabled : function (errorCode) {
			this.$("#editLgConferencesEnabledGrp").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#editLgConferencesEnabledErrMsg").html("Conferences input is empty");
					this.$("#editLgConferencesEnabledErrMsg").show();
					break;
				default : 
					this.$("#editLgConferencesEnabledErrMsg").html("Conferences input is invalid");
					this.$("#editLgConferencesEnabledErrMsg").show();
			}
		},
	});

	var EditLeagueMessageView = Backbone.View.extend({
		initialize: function(options) {
			this.hideAll();
			
			this.event = options.event;
			
			this.listenTo(this.event, 'default', this.hideAll);
			this.listenTo(this.event, 'resetMessages', this.hideAll);
			this.listenTo(this.event, 'saving', this.processing);
			this.listenTo(this.event, 'error', this.error);
			this.listenTo(this.event, 'success', this.success);
		},
		
		hideAll: function() {
			$(this.el).hide();
			this.$("#editLgBodyMessageError").hide();
			this.$("#editLgBodyMessageProcessing").hide();
			this.$("#editLgBodyMessageSuccess").hide();
		},
		
		error: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#editLgBodyMessageError").show();
		},
		
		success: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#editLgBodyMessageSuccess").show();
			this.$("#editLgBodyMessageSuccess").fadeOut(3000);
		},
		
		processing: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#editLgBodyMessageProcessing").show();
		}
	});
	
	var EditLeagueView = Backbone.View.extend({
		el: $("#editLgContent"),
		
		initialize: function(options) {
			this.userModel = options.userModel; 
			this.lgInstance = options.lgInstance;
			this.prodConfig = options.prodConfig;
			this.prodType = options.prodType;
			
			this.event = _.extend({}, Backbone.Events);
			this.submittedData = {isSubmitted : false};
			
			_.bindAll(this, 'hideView');
			_.bindAll(this, 'showView');
			
			this.message = new EditLeagueMessageView({el: this.$("#editLgBodyMessage"), event: this.event});
			this.content = new EditLeagueContentView({
				el: this.$("#editLgBodyContent"), 
				event: this.event,
				submittedData : this.submittedData,
				userModel: this.userModel, 
				lgInstance: this.lgInstance,
				prodConfig: this.prodConfig,
				prodType: this.prodType});
			this.footer = new EditLeagueFooterView({el: this.$("#editLgFooter"), event: this.event});
			
			this.listenTo(this.event, 'savingSuccess', this.editLgSuccess);
			this.listenTo(this.event, 'savingError', this.editLgError);
			
			this.listenTo(this.lgInstance, 'change:draftStatus', this.updateVisuals);
			
			//Setup Form open/hide
			var editLgOpenBtn = this.$("#editLgOpen");
			var editLgCloseBtn = this.$("#editLgFormCancel");
			
			editLgOpenBtn.on('click', {}, this.showView);
			editLgCloseBtn.on('click', {}, this.hideView);
		},
		
		render: function () {
			this.updateVisuals();
			
			this.event.trigger("default");
			return this;
		},
		
		hideView: function() {
			this.event.trigger("resetMessages");
			this.$("#editLgOpen").show();
			this.$("#editLgBodyContent").slideUp();
		},
		
		showView: function() {
			this.$("#editLgOpen").hide();
			this.$("#editLgBodyContent").slideDown();
		},
		
		updateVisuals: function() {
			$(this.el).find('#lgInfoDispName').html(this.lgInstance.get("displayName"));
			$(this.el).find('#lgInfoType').html(this.lgInstance.prettyDraftType());
			$(this.el).find('#lgInfoRounds').html(this.lgInstance.get("numRounds"));
			$(this.el).find('#lgInfoUndo').html(this.lgInstance.get("undoEnabled") ? 'Teams can undo their picks' : 'Only the commissioner can undo a pick');
			$(this.el).find('#lgInfoRanksEnabled').html(this.lgInstance.get("ranksEnabled") ? 'Enabled' : 'Disabled');
			$(this.el).find('#lgInfoProjectionsEnabled').html(this.lgInstance.get("statsEnabled") ? 'Enabled' : 'Disabled');
			
			if(this.lgInstance.get("rookieEnabled") && this.lgInstance.get("vetEnabled")){
				$(this.el).find('#lgInfoRookiesEnabled').html('Rookies and Veterans');
			} else if(this.lgInstance.get("rookieEnabled")){
				$(this.el).find('#lgInfoRookiesEnabled').html('Rookies Only');
			} else if(this.lgInstance.get("vetEnabled")){
				$(this.el).find('#lgInfoRookiesEnabled').html('Veterans Only');
			}
			
			if(this.lgInstance.get("conf1Enabled") && this.lgInstance.get("conf2Enabled")){
				$(this.el).find('#lgInfoConferencesEnabled').html('Both Conferences');
			} else if(this.lgInstance.get("conf1Enabled")){
				switch (this.lgInstance.get('prodLeagueName')) {
				case 'NFL':
					$(this.el).find('#lgInfoConferencesEnabled').html('AFC Only');
					break;
				case 'MLB':
					$(this.el).find('#lgInfoConferencesEnabled').html('AL Only');
					break;
				case 'NBA':
					$(this.el).find('#lgInfoConferencesEnabled').html('Eastern Only');
					break;
				case 'NHL':
					$(this.el).find('#lgInfoConferencesEnabled').html('Eastern Only');
					break;
				default:
					break;
				}
			} else if(this.lgInstance.get("conf2Enabled")){
				switch (this.lgInstance.get('prodLeagueName')) {
				case 'NFL':
					$(this.el).find('#lgInfoConferencesEnabled').html('NFC Only');
					break;
				case 'MLB':
					$(this.el).find('#lgInfoConferencesEnabled').html('NL Only');
					break;
				case 'NBA':
					$(this.el).find('#lgInfoConferencesEnabled').html('Western Only');
					break;
				case 'NHL':
					$(this.el).find('#lgInfoConferencesEnabled').html('Western Only');
					break;
				default:
					break;
				}
			}
			
			if(this.lgInstance.get('prodLeagueName') != 'NFL'){
				this.$("#lgInfoRookiesEnabledContainer").hide();
			} else {
				this.$("#lgInfoRookiesEnabledContainer").show();
			}
			
			if(this.prodConfig.AUTODRAFT == 'true'){
				switch (this.lgInstance.get("timerExpType")) {
				case "NONE":
					$(this.el).find('#lgInfoTimerExpiration').html('Manual - Timer will stay expired');
					break;
				case "AUTO_TOP_RANKED":
					$(this.el).find('#lgInfoTimerExpiration').html('Autodraft - Best Ranked (Rankings only)');
					break;
				case "AUTO_POS_SCARCITY":
					$(this.el).find('#lgInfoTimerExpiration').html('Autodraft - Recommended (Based on rankings and positions)');
					break;
				case "SKIP_PICK_ANYTIME":
					$(this.el).find('#lgInfoTimerExpiration').html('Skip - May make up selection any time');
					break;
				default:
					$(this.el).find('#lgInfoTimerExpiration').html('Manual - Timer will stay expired');
					break;
				}
			} else {
				$(this.el).find('#lgInfoTimerExpiration').html('Timer not available (<a href="/draftapp/dashboard/purchase">Upgrade</a> to enable)');
			}
			
			//Determine whether to show the Edit League form button and join key
			if(this.lgInstance.isCommissioner(this.userModel.get('userName')) 
					&& this.lgInstance.get("draftStatus") != "COMPLETED"
					&& this.prodType.get('active')){
				this.$("#editLgOpen").show();
				
				$(this.el).find('#lgInfoKey').html(this.lgInstance.get('leagueName').toLowerCase() + this.lgInstance.get('password').toLowerCase());
				this.$("#lgInfoKeyGrp").show();
			} else {
				this.$("#editLgOpen").hide();
				this.$("#lgInfoKeyGrp").hide();
			}			
			
			this.content.render();
		},
		
		editLgError: function(model, error) {
			if(this.submittedData.isSubmitted){
				if (error.status == 400) {
					//Input errors
					this.event.trigger("error");
					
					var errObj = JSON.parse(error.responseText);
					
					if(errObj.code){
						for(var i=0; i< errObj.code.length; i++){
							if(errObj.code[i].indexOf("_") > 0){
								//Trigger a specific event for the field with the code attached as a param
								var errCode = errObj.code[i].substring(0, errObj.code[i].indexOf("_"));
								var field = errObj.code[i].substring(errObj.code[i].indexOf("_") + 1);
								this.event.trigger("error:" + field.toLowerCase(), errCode);
							}
						}
					}
				} else {
					this.event.trigger("error");
				}
				
				this.submittedData.isSubmitted = false;
			}
		},
		
		editLgSuccess: function () {
			if(this.submittedData.isSubmitted){
				this.submittedData.isSubmitted = false;
				this.event.trigger("success");
			}

			this.$("#editLgOpen").show();
			this.$("#editLgBodyContent").hide();
			this.updateVisuals();
			//this.model.trigger("reset");
		}
	});
	
	return EditLeagueView;  
});